import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useGetDate } from '../../hooks/useGetDate'
import { useSetMonthlyTour } from '../../hooks/useSetMonthlyTour';
import { ApiStorage, ApiUrl } from '../../services/ApiRest';
import { FooterScreen } from '../footer/FooterScreen';
import { NavBarScreen } from '../navBar/NavBarScreen'
import { WhatsappButtonScreen } from './whatsappButton/WhatsappButtonScreen';
import { useGetDateToDayMonth } from '../../hooks/useGetDateToDayMonth';

export const MonthlyTourScreen = () => {
    // localStorage.removeItem("menu");
    // window.localStorage.setItem("menu", 2);

    const { printMonth, printNextMonth, date } = useGetDate();

    const [tours, settours] = useState([]);

    const getData = async () => {
        await axios.get(ApiUrl + "monthly-tour-list")
            .then(response => {
                const data = response.data;
                console.log(data);
                settours(data);
            })
            .catch(e => {
                console.log(e);
            })
    }

    const convertDate = (date) => {
        const { letterMonth, day } = useGetDateToDayMonth(date);
        var dateText = day + ' ' + 'DE ' + letterMonth;
        return (dateText);
    }

    useEffect(() => {
        getData();
    }, [])

    const { monthlyTour, nextMonthlyTour } = useSetMonthlyTour(tours);
    console.log(nextMonthlyTour);

    return (
        <>
            <NavBarScreen />
            <div className="cont_img animate__animated animate__fadeIn" >
                <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
                    <div className="carousel-inner" role="listbox">

                        <div className="banner" data-bs-interval="4000" style={{ backgroundImage: `url('./assets/images/principal/monthly-tour.jpeg')` }}>
                            <div className="pantalla_dividida" style={{ height: "45vh" }}>
                                <div className="text_cent_img_dividida animate__animated animate__fadeInRight animate__delay-0.8s">
                                    <h1 className="tit-sob-img_dividida" style={{ textShadow: '1px 1px 2px rgba(0,0,0,1.5)', letterSpacing: '0px' }}>Reserva tu cupo ahora <br />y comienza a crear recuerdos </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <div className='container'>
                <h5 style={{ textAlign: 'center' }}>Tenemos estas rutas disponibles para el mes de <b>{printMonth} y {printNextMonth} </b> asi que acompañanos a vivir estas aventuras que tenemos planificadas para ti. Escoge la que más te guste y disfrutala al máximo junto a tus amigos, pareja o familia</h5>
                <br></br>
                <h1 className="camping-letters text-center" >TOURS DE {printMonth}</h1>
                {
                    (monthlyTour.length === 0) ?
                        <h5 style={{ textAlign: 'center' }}>Por el momento no tenemos rutas disponibles para {printMonth} pronto tendremos más información </h5>
                        :
                        ''
                }
            </div>

            {/* Cards para el mes actual */}
            <div className='container'>
                <div className='row'>
                    {monthlyTour.map((tour, index) => (
                        <div className='col-6 col-sm-6 col-md-3 current-month-card sm-screen' key={tour.monthly_tour_id} style={{ marginBottom: '1.5rem' }}>
                            <Link to={`/tour-mensual/${tour.monthly_tour_id}`} className="text-decoration-none text-dark">
                                <div className="card h-100 shadow tour-card-hover" style={{ borderRadius: "1.5rem" }}>

                                    {/* Imagen con contenedor relativo */}
                                    <div className="card-img-container position-relative" style={{ height: '200px', overflow: 'hidden' }}>
                                        <img
                                            src={`${ApiStorage + tour.img_1}`}
                                            className="card-img-top"
                                            alt={tour.tour_destiny}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderTopLeftRadius: '1.5rem',
                                                borderTopRightRadius: '1.5rem'
                                            }}
                                        />

                                        {/* Precio flotante */}
                                        <div
                                            className="position-absolute bottom-0 end-0 m-2 px-2 py-1 text-white rounded"
                                            style={{
                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                fontSize: '0.85rem'
                                            }}
                                        >
                                            <>${tour.person_cost}</>
                                        </div>
                                    </div>

                                    {tour.tour_destiny.toUpperCase().includes("PUÑAY") && (
                                        <div className="badge bg-warning text-dark position-absolute top-0 start-0 m-2">
                                            Más vendido
                                        </div>
                                    )}


                                    <div className="card-body d-flex flex-column align-items-center" style={{ padding: '1rem' }}>
                                        <div className="text-center mb-3">
                                            <small className="d-block" style={{ fontWeight: '600' }}>
                                                {tour.type === "Full Day" ? "🥾" : tour.type === "Camping" ? "🏕️" : "🏔️"}
                                                {tour.type}
                                            </small>
                                            <p className="camping-letters mb-1 fw-bold">{tour.tour_destiny}</p>
                                            <small className="d-block" style={{ fontWeight: '600' }}>{convertDate(tour.departure_date)}</small>
                                            <small className="d-block text-muted" style={{ fontWeight: '600' }}>
                                                Desde: {tour.meeting_point}
                                            </small>
                                            <small className="text-muted" style={{ fontWeight: '600' }}>
                                                {tour.type === "Full Day" ? "1 día completo" : tour.type === "Intento de Cumbre" ? "1 día completo" : "2 días / 1 noche"}
                                            </small>

                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>


                    ))}
                </div>
            </div>

            <br></br>
            <div className='container'>
                <h1 className="camping-letters text-center">TOURS DE {printNextMonth}</h1>
                {
                    (nextMonthlyTour.length === 0) ?
                        <h5 style={{ textAlign: 'center' }}>Por el momento no tenemos rutas disponibles para {printNextMonth} pronto tendremos más información </h5>
                        :
                        ''
                }
            </div>

            {/* Cards para el próximo mes */}
            <div className='container'>
                <div className='row'>
                    {nextMonthlyTour.map((tour, index) => (
                        <div className='col-6 col-sm-6 col-md-3 current-month-card sm-screen' key={tour.monthly_tour_id} style={{ marginBottom: '1.5rem' }}>
                            <Link to={`/tour-mensual/${tour.monthly_tour_id}`} className="text-decoration-none text-dark">
                                <div className="card h-100 shadow tour-card-hover" style={{ borderRadius: "1.5rem" }}>

                                    {/* Imagen con contenedor relativo */}
                                    <div className="card-img-container position-relative" style={{ height: '200px', overflow: 'hidden' }}>
                                        <img
                                            src={`${ApiStorage + tour.img_1}`}
                                            className="card-img-top"
                                            alt={tour.tour_destiny}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderTopLeftRadius: '1.5rem',
                                                borderTopRightRadius: '1.5rem'
                                            }}
                                        />

                                        {/* Precio flotante */}
                                        <div
                                            className="position-absolute bottom-0 end-0 m-2 px-2 py-1 text-white rounded"
                                            style={{
                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                fontSize: '0.85rem'
                                            }}
                                        >
                                            <>${tour.person_cost}</>
                                        </div>
                                    </div>

                                    {tour.tour_destiny.toUpperCase().includes("PUÑAY") && (
                                        <div className="badge bg-warning text-dark position-absolute top-0 start-0 m-2">
                                            Más vendido
                                        </div>
                                    )}


                                    <div className="card-body d-flex flex-column align-items-center" style={{ padding: '1rem' }}>
                                        <div className="text-center mb-3">
                                            <small className="d-block" style={{ fontWeight: '600' }}>
                                                {tour.type === "Full Day" ? "🥾" : tour.type === "Camping" ? "🏕️" : "🏔️"}
                                                {tour.type}
                                            </small>
                                            <p className="camping-letters mb-1 fw-bold">{tour.tour_destiny}</p>
                                            <small className="d-block" style={{ fontWeight: '600' }}>{convertDate(tour.departure_date)}</small>
                                            <small className="d-block text-muted" style={{ fontWeight: '600' }}>
                                                Desde: {tour.meeting_point}
                                            </small>
                                            <small className="text-muted" style={{ fontWeight: '600' }}>
                                                {tour.type === "Full Day" ? "1 día completo" : tour.type === "Intento de Cumbre" ? "1 día completo" : "2 días / 1 noche"}
                                            </small>

                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
            <br></br>
            <br></br>
            <WhatsappButtonScreen />
            <FooterScreen />
        </>
    )
}